import { CommonModule } from '@angular/common';
import {
	AfterContentChecked,
	AfterContentInit,
	AfterViewChecked,
	AfterViewInit,
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnInit,
	Output,
	SimpleChanges,
} from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { LabelsService } from 'src/app/util/services/labels/labels.service';

@Component({
	standalone: true,
	imports: [CommonModule, FontAwesomeModule],
	selector: 'cpi-checkbox',
	templateUrl: './checkbox.component.html',
	styleUrls: ['./checkbox.component.scss'],
})
export class CheckboxComponent implements OnInit, OnChanges {
	icons = {
		faCheck: faCheck,
		faTimes: faTimes,
	};

	@Input() forceText = true;
	@Input() hideCheck = false;
	@Input() hideUncheck = false;
	@Input() disable = false;

	constructor() {}

	@Input() value: any = null;
	@Output() oValue = new EventEmitter();

	@Input() shared = null;
	@Input() innerText = '';

	@Input() color = 'var(--danger)';
	@Input() colorChecked = 'var(--success)';

	toggleAnim: boolean;

	@Output() onClickDisabled = new EventEmitter();
	@Input() disabledByTemplate = false;

	ngOnInit(): void {}

	ngOnChanges(changes: SimpleChanges): void {
		if (
			(changes && changes.value && changes.value.previousValue && changes.value.currentValue != changes.value.previousValue) ||
			(changes && changes.shared && changes.shared.previousValue && changes.shared.currentValue != changes.shared.previousValue)
		) {
			this.toggleAnim = true;
		}
	}

	//Quando tem um valor shared definido, ele trata como radio e o 'value' fica fixo com o valor do radio
	detectChanges(): void {
		if (this.disabledByTemplate) {
			this.onClickDisabled.emit(true);
			return;
		}

		if (this.shared === null) {
			this.value = this.value == 0 ? 1 : 0;
			this.oValue.emit(this.value);
		} else {
			this.shared = this.value;
			this.oValue.emit(this.value);
		}
	}
}
